import React, { useState } from "react";
import timeIcon from "../../../assets/images/timeIcon.svg";
import { parseISO, format, isBefore } from "date-fns";
import YoutubeEmbed from "./YoutubeEmbed";

export const UpcommingEvent = ({ data, event, handleViewClick }) => {
  const [activeVideoId, setActiveVideoId] = useState(null);
  const handleCardClick = (id) => {
    handleViewClick(id);
  };

  const today = new Date();

  const extractYouTubeVideoId = (url) => {
    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div className="flex flex-col gap-4 ">
      <div className="flex flex-col gap-4 ">
        <h2 className="text-[#000] text-[24px] font-ManropeBold">Events</h2>
        <h2 className="text-[12px] text-[#525252] font-ManropeSemibold leading-[20px] ">
          See Upcoming and Past Events
        </h2>
        <div className="flex gap-12 items-center">
          <div className="flex gap-2 items-center">
            <span className="w-[16px] h-[16px] bg-[#864AFC] rounded-full"></span>
            <h2>Upcoming Events</h2>
          </div>
          <div className="flex gap-2 items-center">
            <span className="w-[16px] h-[16px] bg-[#05A6B2] rounded-full"></span>
            <h2>Past Events</h2>
          </div>
        </div>
      </div>

      {data.map((event) => {
        const isPastEvent = isBefore(parseISO(event.date), today);
        const stickColor = isPastEvent ? "bg-[#05A6B2]" : "bg-[#864AFC]";

        return (
          <div
            className="flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer"
            onClick={() => handleCardClick(event.id)}
            key={event.id}
          >
            <div className={`w-[12px] h-[100px] ${stickColor}`}></div>
            <div className="h-full flex flex-col gap-2">
              <span className="font-inter font-bold md:text-[20px] leading-[24.2px]">
                {format(parseISO(event.date), "dd")}
              </span>
              <span className="font-inter text-[14px] text-[#7A7A7A]">
                {format(parseISO(event.date), "MMM")}
              </span>
            </div>
            <img
              src={event.thumbnail}
              alt="event-image"
              className={`w-[150px] h-[88px] md:w-[150px] md:h-[88px] rounded-[4px] object-cover`}
            />
            <div className="flex gap-2 flex-col">
              <h2 className="text-[14px] leading-[18px] font-ManropeBold">
                {event.name}
              </h2>
              {event && (
                <p className="text-[12px] font-ManropeLight">
                  {event.description}
                </p>
              )}
              <div className="flex items-center gap-1 text-[#666666] text-[12px] font-ManropeLight ">
                <img src={timeIcon} alt="time-icon" />
                <p className="text-xs text-gray-500 ">
                  {event.startTime} - {event.endTime}
                </p>
              </div>
              <div>
                {event.capacity === "Online" ? (
                  <>
                    <button
                      className="text-blue-600 underline text-[12px]"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveVideoId(extractYouTubeVideoId(event.location));
                      }}
                    >
                      Join Online Event {event.location}
                    </button>
                    {activeVideoId ===
                      extractYouTubeVideoId(event.location) && (
                      <YoutubeEmbed
                        embedId={extractYouTubeVideoId(event.location)}
                      />
                    )}
                  </>
                ) : (
                  <p className="text-[12px] text-gray-700">{event.location}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
